import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";

export const InstructorSkeletonItem = () => {
  return (
    <div className="pt-6  px-4     pb-6  space-y-4">
      <RectangularSkeleton height={24} width={128} className=" rounded" />
      <RectangularSkeleton height={96} width={"100%"} className=" rounded" />
    </div>
  );
};
